import { createContext, useContext } from 'react';

/**
 * Server-clock offset in milliseconds: `serverNow ≈ Date.now() + offset`.
 * Computed once per connection from a ping/pong round-trip in LobbySession
 * and provided at the App root. Default 0 means "assume client clock ==
 * server clock" — every Timer/Hourglass rendered without a provider (tests,
 * the lobby, design mocks) keeps its pre-skew behavior.
 */
export const ClockOffsetContext = createContext<number>(0);

export function useClockOffset(): number {
  return useContext(ClockOffsetContext);
}
